module.exports = __webpack_public_path__ + "img/f1.559b8554.jpg";